import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { message } from '@nula/core-ui';
import { useNavigate } from '@tanstack/react-router';
import { useWorkspaceStore } from '@/stores/use-workspace-store';
import { onWorkspaceMembershipChanged, type WorkspaceMembershipChange } from '@/lib/sync/sync-event-bus';

export function MembershipBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onWorkspaceMembershipChanged(async (change: WorkspaceMembershipChange) => {
      const store = useWorkspaceStore.getState();
      try {
        await store.refreshFromServer();
      } catch (err) {
        console.error('[MembershipBridge] refreshFromServer after membership change failed:', err);
        Sentry.captureException(err);
      }
      if (change.change === 'removed') {
        message.warning('You were removed from this workspace.');
        const fallbackId = useWorkspaceStore.getState().activeWorkspaceId;
        if (fallbackId) {
          await useWorkspaceStore.getState().switchToWorkspace(
            fallbackId,
            (path) => navigate({ to: path }),
          );
        }
      } else if (change.change === 'role_changed') {
        message.info(`Your role in this workspace changed to ${change.newRole}.`);
      }
    });
    return unsub;
  }, [navigate]);

  return null;
}
